"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getFileUrl = exports.getFileType = exports.getFileNameSuffix = exports.getFileName = exports.getFile = void 0;
require("core-js/modules/es.array.map.js");
require("core-js/modules/es.iterator.constructor.js");
require("core-js/modules/es.iterator.map.js");
require("core-js/modules/es.object.to-string.js");
require("core-js/modules/es.regexp.exec.js");
require("core-js/modules/es.string.replace.js");
/** 获取 文件
 * @description: 根据路径获取文件内容
 * @param { String | Array } url 文件路径
 * @param { Boolean } useSubdirectories 是否包含子目录
 * @param { regExp } regExp 是否包含子目录
 * @return { file } 搜索到的文件
 */
var getFile = exports.getFile = function getFile(url) {
  var useSubdirectories = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  var regExp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : /^\.\//;
  return require.context('./', useSubdirectories, regExp);
};
var StringOrArray = function StringOrArray() {
  var _arguments$, _arguments$2;
  var a = arguments[0];
  var b = (_arguments$ = arguments[1]) !== null && _arguments$ !== void 0 ? _arguments$ : /^\.\//;
  var c = (_arguments$2 = arguments[2]) !== null && _arguments$2 !== void 0 ? _arguments$2 : '';
  if (typeof a === 'string') return a === null || a === void 0 ? void 0 : a.replace(b, c);else if (Array.isArray(a)) return a === null || a === void 0 ? void 0 : a.map(function (u) {
    return u === null || u === void 0 ? void 0 : u.replace(b, c);
  });
  return null;
};

/** 获取 文件路径中的 文件夹路径
 * @description: 根据路径获取文件内容
 * @param { String | Array } url 文件路径
 * @return { String } 文件夹路径
 */
var getFileUrl = exports.getFileUrl = function getFileUrl(url) {
  return StringOrArray(url, /([^\\/]+)\.([^\\/]+)/, '');
};

/** 获取 文件路径 中的文件名
 * @description: 获取 文件路径 中的文件名
 * @param { String | Array } url 文件路径
 * @param { Boolean } suffix 是否携带后缀名，默认 false-不带
 * @return { String } 文件名
 */
var getFileName = exports.getFileName = function getFileName(url) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return StringOrArray(url, suffix ? /(.*\/)*([^.]+)/ig : /(.*\/)*([^.]+).*/ig, '$2');
};

/** 获取 文件路径 中的 后缀名
 * @description: 获取 文件路径 后缀名
 * @param { String | Array } url 文件路径
 * @param { Boolean } suffix 是否携带 ‘.’ ，默认 false-不带
 * @return { String } 后缀名
 */
var getFileNameSuffix = exports.getFileNameSuffix = function getFileNameSuffix(url) {
  var suffix = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
  return StringOrArray(url, /.+\./, suffix ? '.' : '');
};

/** 判断文件类型是否是图片
 * @description: 通过文件名（包含后缀名）或者后缀名单次 判断文件的类型
 * @param { String } url 文件
 * @return { Promise } 后缀名
 */
var getFileType = exports.getFileType = function getFileType(url) {
  // return new Promise((resolve, reject) => {
  //   const controller = new AbortController()
  //   const getFile = axios.create({})

  //   // console.log(axios, getFile)

  //   getFile.interceptors.request.use(
  //     config => {
  //       console.log(config)
  //       // return
  //       // controller.abort()
  //       return config
  //     }
  //   )

  //   getFile.interceptors.response.use(
  //     response => {
  //       console.log('response', response)
  //     },
  //     error => {
  //       console.log('error', { ...error })
  //     }
  //   )

  //   getFile.get(url, { responseType: 'blob', signal: controller.signal })
  //   // getFile.
  //   // // console.log(url)
  //   // getFile
  //   //   .get(url, { responseType: 'blob' })
  //   //   .then(resolve)
  //   //   .catch(reject)

  //   // const reader = new FileReader()
  //   // console.log('reader 1', reader)
  //   // reader[readAs](file)
  //   // reader.onload = () => {
  //   //   console.log('reader 2', reader)
  //   //   resolve(reader)
  //   // }

  //   // reader.onerror = reject
  // })
  return false;
};